import { Icon } from '@/shared/components'
import { pxToRem } from '@/shared/styles/themes'
import { faFile } from '@fortawesome/pro-light-svg-icons'
import { styled, Typography } from '@mui/material'

export type OrderDetailsPlaceholderProps = {
  //
}

export const OrderDetailsPlaceholder: React.FC<OrderDetailsPlaceholderProps> = ({ }) => {
  return (
    <StyledContainer>
      <StyledIcon icon={faFile}/>
      <StyledTypography variant="body1">
        No order was selected. Please select an order from the tables to view its details.
      </StyledTypography>
    </StyledContainer>
  )
}

const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.text.dim};
  font-size: ${pxToRem(32)};
  margin-bottom: ${pxToRem(16)};
`


const StyledContainer = styled('div')`
  position: relative;
  width: 100%;
  border-radius: ${pxToRem(8)} 0 0 ${pxToRem(8)};
  box-shadow: 4pxpx 6px 8px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  padding: 0 0 ${pxToRem(8)} 0;
  margin: ${pxToRem(10)} 0 0 0;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${pxToRem(32)} 0;
`

const StyledTypography = styled(Typography)`
  font-weight: 500;
  font-size: ${pxToRem(14)};
  color: ${({ theme }) => theme.palette.text.dim};
`